// extracted by mini-css-extract-plugin
export var acceptButton = "_26-5";
export var fullContent = "_26-4";
export var link = "_26-6";
export var linkIcon = "_26-7";
export var sideContent = "_26-3";
export var sideImage = "_26-2";
export var sideImageWrapper = "_26-1";
export var splitLayout = "_26-0";